import { DropdownProps, DropdownType, DropdownWidget, InlineBlock, MenuItemInfo, SearchFieldProps, SearchFieldWidget } from '@tableau/widgets';
import * as React from 'react';
import { Messages } from '../../../codegen/Localize';
import { CommonStyles } from '../CommonStyles';
import { IReactTranslateService } from '../IReactTranslateService';

export class SiteMembershipFilters extends React.PureComponent<SiteMembershipFilters.Props, {}> {

  handleSelection = (newOption: string) => {
    this.props.onFilterSelected(newOption);
  }

  getFilters = (): MenuItemInfo[] => {
    return this.props.filters.map((filter: string) => {
      return {
        value: filter,
        displayValue: this.props.translate(filter),
      };
    });
  }

  public render() {
    let membershipSearchProps: SearchFieldProps = this.createMembershipSearchProps();
    let membershipSelectProps: DropdownProps = this.createMembershipSelectDropdownProps();

    return (
      <div>
        <DropdownWidget {...membershipSelectProps} />
        <SearchFieldWidget {...membershipSearchProps} />
      </div>
    );
  }

  public createMembershipSelectDropdownProps() {
    let membershipSelectProps: DropdownProps = {
      selectedValue: this.props.siteFilterSelection,
      onSelect: this.handleSelection,
      dropdownType: DropdownType.Outline,
      testId: 'site-membership-select',
      menuItemInfos: this.getFilters(),
      placeholder: this.props.translate(this.props.siteFilterSelection),
      containerStyle: {
        width: 150,
        fontFamily: CommonStyles.Fonts.HeavyFont,
        float: 'left'
      }
    };
    return membershipSelectProps;
  }

  public createMembershipSearchProps() {
    let membershipSearchProps: SearchFieldProps = {
      handleChange: this.props.onSearchInputTextChange,
      handleCancelSearch: this.props.onCancelSearch,
      placeholder: Messages.searchSites(),
      testId: 'site-membership-search',
      text: this.props.searchInputText,
      containerStyle: {
        width: 325,
        fontFamily: CommonStyles.Fonts.HeavyFont,
        float: 'right'
      }
    };
    return membershipSearchProps;
  }
}

export namespace SiteMembershipFilters {

  export interface Props {
    readonly filters: string[];
    readonly onFilterSelected: (value: string) => void;
    readonly siteFilterSelection: string;
    readonly onCancelSearch: () => void;
    readonly onSearchInputTextChange: (value: string) => void;
    readonly searchInputText?: string;
    translate: IReactTranslateService;
  }
}
